'use client'

import cn from 'classnames'
import { useTranslations } from 'next-intl'
import { Modal } from '@booking/components/Modal'
import styles from '../index.module.scss'

export default function GroupSizeModal({
  open,
  onOpenChange,
}: {
  open: boolean
  onOpenChange: (open: boolean) => void
}) {
  const t = useTranslations('booking')

  return (
    <Modal modalIsOpen={open} setModalIsOpen={onOpenChange} className={cn(styles.modal)}>
      <h3 className={styles.title}>{t('ticket.selectQuantity.groupsize.title')}</h3>

      <div className={styles.content}>
        {t.rich('ticket.selectQuantity.groupsize.content', {
          contact: (chunks) => <a href="mailto:booking@lisbonquake.com">{chunks}</a>,
        })}
      </div>
    </Modal>
  )
}
